import { IWindowUser } from '../interfaces/window/IWindowUser';

const getWindowUser = () => {
  const windowUser = (window as any).USER as IWindowUser;
  return windowUser;
};

export { getWindowUser };
